import { c as _c } from "react/compiler-runtime";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { Box } from "@mui-wrapper";
import { MarkupActionMoreOptions } from "@pages/project-details/project-markups/markup-action-more-options";
import { MarkupActionSphereViewer } from "@pages/project-details/project-markups/markup-action-sphere-viewer";

/** Markup actions buttons displayed in a markups table */
export function MarkupActions(t0) {
  const $ = _c(9);
  const {
    markup
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== markup) {
    t2 = <MarkupActionSphereViewer markup={markup} />;
    $[1] = markup;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SphereActionDivider />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== markup) {
    t4 = <MarkupActionMoreOptions markup={markup} />;
    $[4] = markup;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <Box component="div" sx={t1}>{t2}{t3}{t4}</Box>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}